/**
 * LibraryFavorite (お気に入り書誌 DTO) を CalilBook に変換する。
 *
 * お気に入りタブで既存の `BookList` / `BookCard` UI を再利用するために、
 * サーバに保存されたスナップショットから Calil の書誌形と同じ shape を作る。
 * holdings / url は空で開始し、カード展開時の ISBN 二次検索 (`enrichBookByIsbn`)
 * によって最新の所蔵情報が埋められる。
 */

import type { CalilBook } from '@/api/types/calil'
import type { LibraryFavorite } from '@/api/types/library-favorite'

export const favoriteToBook = (favorite: LibraryFavorite): CalilBook => ({
  id: `favorite-${favorite.isbn}`,
  isbn: favorite.isbn,
  title: favorite.title,
  author: favorite.author,
  publisher: favorite.publisher,
  pubdate: favorite.pubdate,
  cover: favorite.cover,
  holdings: [],
  estimated_holdings: [],
  url: {},
})
